<template>
    <label class="block" :class="{ 'max-w-4xl': !fullWidth }">
        <div class="flex justify-between">
            <span class="text-gray-700 dark:text-gray-200">{{ label }}</span>
            <span v-if="maxlength" class="text-gray-200">{{charInserted}} out of {{maxlength}}</span>
        </div>
        <textarea
            class="block w-full text-black dark:text-white bg-white dark:bg-gray-700 border-gray-300 rounded-md focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50 mt-1 disabled:opacity-50"
            :name="name"
            :value="value"
            @input="(e) => $emit('input', e.target.value)"
            :disabled="disabled"
            :maxlength="maxlength"
            :keyup="countdown"
        ></textarea>
        <error class="mt-1" :error="error" />
    </label>
</template>

<script>
export default {
    name: "InputTextarea",
    props: {
        name: String,
        label: String,
        value: String,
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        error: {
            type: String,
            required: false,
        },
        maxlength: {
            type: Number,
            required: false,
        },
        fullWidth: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            charInserted: 0
        };
    },
    computed: {
        countdown () {
            this.charInserted = this.value ? this.value.length : 0;
        },
    }
};
</script>
